import {
  RESET_CLIENT_SYSTEM_VARIABLE_VALUES,
  RESET_CLIENT_SYSTEM_VARIABLE_VALUE,
  RESET_ERROR,
  GET_CLIENT_SYSTEM_VARIABLE_VALUES,
  SET_CLIENT_SYSTEM_VARIABLE_VALUES,
  API_ERROR,
  GET_CLIENT_SYSTEM_VARIABLE_VALUE,
  SET_CLIENT_SYSTEM_VARIABLE_VALUE,
  CREATE_CLIENT_SYSTEM_VARIABLE_VALUE,
  CREATE_CLIENT_SYSTEM_VARIABLE_VALUE_SUCCESS,
  EDIT_CLIENT_SYSTEM_VARIABLE_VALUE,
  EDIT_CLIENT_SYSTEM_VARIABLE_VALUE_SUCCESS,
  DELETE_CLIENT_SYSTEM_VARIABLE_VALUE,
  DELETE_CLIENT_SYSTEM_VARIABLE_VALUE_SUCCESS,
} from "./actionTypes";

export const resetClientSystemVariables = () => {
  return {
    type: RESET_CLIENT_SYSTEM_VARIABLE_VALUES,
    payload: {},
  };
};

export const resetClientSystemVariable = () => {
  return {
    type: RESET_CLIENT_SYSTEM_VARIABLE_VALUE,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getClientSystemVariables = (idCompany, page, qnt, name) => {
  return {
    type: GET_CLIENT_SYSTEM_VARIABLE_VALUES,
    payload: { idCompany, page, qnt, name },
  };
};
export const setClientSystemVariables = (data, qtdDefault, idCompany) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_CLIENT_SYSTEM_VARIABLE_VALUES,
    payload: { ...data, paging, idCompany },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createClientSystemVariable = (
  newClientSystemVariableValues,
  idCompany
) => {
  return {
    type: CREATE_CLIENT_SYSTEM_VARIABLE_VALUE,
    payload: { newClientSystemVariableValues, idCompany },
  };
};
export const createClientSystemVariableSuccess = (message) => {
  return {
    type: CREATE_CLIENT_SYSTEM_VARIABLE_VALUE_SUCCESS,
    payload: { message },
  };
};

export const getClientSystemVariable = (
  idClientSystemVariable,
  idCompany,
  isForm
) => {
  return {
    type: GET_CLIENT_SYSTEM_VARIABLE_VALUE,
    payload: { idClientSystemVariable, idCompany, isForm },
  };
};
export const setClientSystemVariable = (data) => {
  return {
    type: SET_CLIENT_SYSTEM_VARIABLE_VALUE,
    payload: { data },
  };
};

export const editClientSystemVariable = (
  idClientSystemVariable,
  newClientSystemVariableValues,
  idCompany
) => {
  return {
    type: EDIT_CLIENT_SYSTEM_VARIABLE_VALUE,
    payload: {
      idClientSystemVariable,
      newClientSystemVariableValues,
      idCompany,
    },
  };
};
export const editClientSystemVariableSuccess = (message) => {
  return {
    type: EDIT_CLIENT_SYSTEM_VARIABLE_VALUE_SUCCESS,
    payload: { message },
  };
};

export const deleteClientSystemVariable = (
  idClientSystemVariable,
  idCompany
) => {
  return {
    type: DELETE_CLIENT_SYSTEM_VARIABLE_VALUE,
    payload: { idClientSystemVariable, idCompany },
  };
};
export const deleteClientSystemVariableSuccess = (message) => {
  return {
    type: DELETE_CLIENT_SYSTEM_VARIABLE_VALUE_SUCCESS,
    payload: { message },
  };
};
